export type Location = "montreal" | "delson";

export const STORE_HOURS: Record<Location, Record<number, { open: number; close: number } | null>> = {
    montreal: {
        // Monday = 0, Sunday = 6
        0: null, // Closed
        1: { open: 11, close: 21 }, // Tuesday
        2: { open: 11, close: 21 }, // Wednesday
        3: { open: 11, close: 21 }, // Thursday
        4: { open: 11, close: 21 }, // Friday
        5: { open: 11, close: 21 }, // Saturday
        6: { open: 11, close: 21 }, // Sunday
    },
    delson: {
        0: null, // Monday - Closed
        1: null, // Tuesday - Closed
        2: { open: 16, close: 20.5 }, // Wednesday 4PM-8:30PM
        3: { open: 11, close: 21 }, // Thursday
        4: { open: 11, close: 21 }, // Friday
        5: { open: 11, close: 21 }, // Saturday
        6: { open: 11, close: 21 }, // Sunday
    }
};

export const getMontrealTime = (): Date => {
    const now = new Date();
    const montrealTime = new Date(
        now.toLocaleString("en-US", { timeZone: "America/Montreal" })
    );
    return montrealTime;
};

export const isLocationOpen = (location: Location): boolean => {
    const now = getMontrealTime();
    const dayOfWeek = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
    const adjustedDay = dayOfWeek === 0 ? 6 : dayOfWeek - 1;

    const hours = STORE_HOURS[location][adjustedDay];

    if (!hours) {
        return false;
    }

    const currentHour = now.getHours() + now.getMinutes() / 60;
    return currentHour >= hours.open && currentHour < hours.close;
};

export const getStatusInfo = (
    location: Location,
    lang: "en" | "fr"
): { isOpen: boolean; message: string } => {
    const isOpen = isLocationOpen(location);

    if (isOpen) {
        return {
            isOpen: true,
            message: lang === "fr" ? "Ouvert maintenant" : "Open now",
        };
    } else {
        return {
            isOpen: false,
            message: lang === "fr" ? "Fermé" : "Closed",
        };
    }
};
